<h1 mat-dialog-title style="background-color: #7bd336; color: white; text-align: center; margin: -24px -24px 20px -24px; padding: 15px; font-weight: 500; font-size: 16px;">{{ isEdit ? 'EDITAR COLOR' : 'NUEVO COLOR' }}</h1>
<div mat-dialog-content style="padding: 0px 24px 10px 24px; overflow: hidden; display: flex; flex-direction: column; gap: 10px;">
  
  <div style="padding: 10px; border-radius: 4px; margin-bottom: 10px; color: white; font-weight: bold; text-align: center;" 
       [style.background]="themeData.SecondaryColor ? 'linear-gradient(90deg, ' + themeData.PrimaryColor + ', ' + themeData.SecondaryColor + ')' : themeData.PrimaryColor">
    Previsualización del Encabezado
  </div>

  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Nombre</mat-label>
    <input matInput [(ngModel)]="themeData.Name" placeholder="Ej. Naranja" maxlength="50">
  </mat-form-field>

  <div style="display: flex; align-items: center; justify-content: space-between;">
    <span style="font-weight: 500;">Color Principal:</span>
    <input type="color" [(ngModel)]="themeData.PrimaryColor" style="width: 50px; height: 35px; border: none; cursor: pointer; padding: 0;">
  </div>

  <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 10px;">
    <span style="font-weight: 500;">Color Secundario (Opcional):</span>
    <div style="display: flex; align-items: center; gap: 10px;">
      <input type="color" [(ngModel)]="themeData.SecondaryColor" style="width: 50px; height: 35px; border: none; cursor: pointer; padding: 0;" [disabled]="!themeData.SecondaryColor && themeData.SecondaryColor !== '#5bb6e4'">
      <button mat-icon-button (click)="themeData.SecondaryColor = themeData.SecondaryColor ? null : '#5bb6e4'" matTooltip="Alternar secundario">
        <mat-icon>{{ themeData.SecondaryColor ? 'close' : 'add' }}</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="errorMsg" style="color: red; text-align: center; font-size: 12px; margin-top: 10px;">{{ errorMsg }}</div>
</div>
<div mat-dialog-actions style="display: flex; justify-content: center; padding: 0 24px 20px 24px; gap: 20px;">
  <button mat-button (click)="onCancel()" style="background-color: #e0e0e0; color: #333; width: 120px; font-weight: 500; border-radius: 4px;">CANCELAR</button>
  <button mat-button (click)="onUpdate()" style="background-color: #7bd336; color: white; width: 120px; font-weight: 500; border-radius: 4px;">GUARDAR</button>
</div>
